import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import Divider from '@mui/material/Divider';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import { Order } from '../../../store/order/api/interface';
import Image from '../../../components/Image';
import Label from '../../../components/Label';
import { selectPaymentStatusColor } from '../../../utils/selectPaymentStatusColor';
import { formatDate } from '../../../utils/formatTime';
import Scrollbar from '../../../components/Scrollbar';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // Avatar,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  // Stack,
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  Tab,
  Tabs,
  stepConnectorClasses,
  CircularProgress,
} from '@mui/material';
import { decryptString } from '../../../utils/url';
import AssetLightBoxImage from '../../../components/AssetLightBoxImage';
import { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import WarningIcon from '@mui/icons-material/Warning';
import { FaCheckCircle } from 'react-icons/fa';
import { IoBagCheckSharp } from 'react-icons/io5';
import { GrInProgress } from 'react-icons/gr';
import { FaShippingFast } from 'react-icons/fa';
import { FaHandHolding } from 'react-icons/fa';
import RecipientLocationEditDialog from './RecipientLocationEditDialog';
import CardMessageEditDialog from './CardMessageEditDialog';
import RecipientDetailsEditDialog from './RecipientDetailsEditDialog';
import AddressEditDialog from './AddressEditDialog';
import DeliverySlotEditDialog from './DeliverySlotEditDialog';
import LocationEditDialog from './LocationEditDialog';
import { ORDER_STATUS } from '../../../constants';
import TableRowViewOrderDetails from './TableRowViewOrderDetails';
import ServiceLinesPanel from '../View/ServiceLinesPanel';
import OrderBundleItemTableRow from '../components/OrderBundleItemTableRow';
import { hasCakeOrBundleItems, sumOrderItems } from '../../../utils/orderTotals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { createOrderStatusChange } from '../../../store/orderStatusChange/api';
import { ExactDeliverySlot } from '../../../client/services';
import { IsNotNullOrEmpty } from '../../../utils/valid';
import { encryptString } from '../../../utils/url';
import { getOrder } from '../../../store/order/api';
import { useParams } from 'react-router-dom';
import { IParams, OrderStatus } from '../../../enum';
import { FaRegSadTear } from 'react-icons/fa';
import useToggle from '../../../hooks/useToggle';
import { toast } from 'react-toastify';
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  // useMapEvents,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { LatLngExpression } from 'leaflet';
import { customIcon } from '../../../utils/icon';
import CakeEditLogs from './CakeEditLogs';
import ExactDeliverySlotSelector, { ExactDeliverySlotSelectorRef } from '../../../components/ExactDeliverySlotSelector';

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

interface IProps {
  order: Order | undefined;
  setOrder: React.Dispatch<React.SetStateAction<Order | undefined>>;
  onOrderItemUpdate?: (orderItemId: string, updatedData: any) => void;
}

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#EE3750',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#EE3750',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: '#EE3750',
      fontWeight: 600,
    }),
    '& .QontoStepIcon-completedIcon': {
      color: '#EE3750',
      zIndex: 1,
      fontSize: 24,
    },
    '& .QontoStepIcon-circle': {
      width: 12,
      height: 12,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
  })
);

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot
      ownerState={{ active }}
      className={className}
    >
      {completed ? (
        <FaCheckCircle className='QontoStepIcon-completedIcon' />
      ) : (
        <div className='QontoStepIcon-circle' />
      )}
    </QontoStepIconRoot>
  );
}

interface Steps {
  name: string;
  icon: any;
}

const steps: Steps[] = [
  {
    name: 'Order Placed',
    icon: (
      <IoBagCheckSharp
        style={{ height: '20px', width: '20px', color: '#808080' }}
      />
    ),
  },
  {
    name: 'Preparing',
    icon: (
      <GrInProgress
        style={{ height: '20px', width: '20px', color: '#808080' }}
      />
    ),
  },
  {
    name: 'Out for Delivery',
    icon: (
      <FaShippingFast
        style={{ height: '20px', width: '20px', color: '#808080' }}
      />
    ),
  },
  {
    name: 'Delivered',
    icon: (
      <FaHandHolding
        style={{ height: '20px', width: '20px', color: '#808080' }}
      />
    ),
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Grid mt={1}>{children}</Grid>}
    </div>
  );
}

const ViewOrder: React.FC<IProps> = ({ order, setOrder, onOrderItemUpdate }) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const params = useParams<IParams>();
  const boxRef = useRef<HTMLDivElement>(null);
  const [tabValue, setTabValue] = useState<number>(0);
  const [openLightBox, setOpenLightBox] = useState(false);
  const [imageState, setImageState] = useState<any>();
  const [refundForCancel, setRefundForCancel] = useState<boolean>(true);
  const { toggle, onOpen, onClose } = useToggle();
  const userRole = useAppSelector((state) => state.auth.user.userRole);
  const [mapCoordinates, setMapCoordinates] = useState<LatLngExpression>([
    25.3548, 51.1839,
  ]);
  const [locationEditDialogOpen, setLocationEditDialogOpen] = useState(false);
  const [cardMessageEditDialogOpen, setCardMessageEditDialogOpen] = useState(false);
  const [recipientDetailsEditDialogOpen, setRecipientDetailsEditDialogOpen] = useState(false);
  const [addressEditDialogOpen, setAddressEditDialogOpen] = useState(false);
  const [deliverySlotEditDialogOpen, setDeliverySlotEditDialogOpen] = useState(false);
  const [exactDeliverySlotDialogOpen, setExactDeliverySlotDialogOpen] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState<string | null>(null);
  const exactDeliverySlotRef = useRef<ExactDeliverySlotSelectorRef>(null);
  const [savingSlot, setSavingSlot] = useState(false);
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );

  useEffect(() => {
    if (order) {
      if (
        order?.shippingAddress?.latitude &&
        order?.shippingAddress?.longitude
      ) {
        setMapCoordinates([
          order?.shippingAddress?.latitude,
          order?.shippingAddress?.longitude,
        ]);
      }
    }
  }, [order]);

  const handleOpenLightBox = (imageObject: any) => {
    setOpenLightBox(true);
    setImageState(imageObject);
  };

  const handleCloseLightBox = () => {
    setOpenLightBox(false);
    setImageState({});
  };

  const renderOrderDetailRows = () => {
    if (!order) return null;

    const orderItemCount = order.order_items?.length ?? 0;

    return (
      <>
        {orderItemCount
          ? order.order_items.map((orderItem, idx) => (
              <TableRowViewOrderDetails
                key={orderItem.id}
                idx={idx}
                orderItem={orderItem}
                order={order}
                handleOpenLightBox={handleOpenLightBox}
                onOrderItemUpdate={onOrderItemUpdate}
              />
            ))
          : null}
        {order.order_bundle_items?.map((bundleItem, i) => (
          <OrderBundleItemTableRow
            key={bundleItem.id}
            bundleItem={bundleItem}
            order={order}
            idx={orderItemCount + i}
            showSpecialRequest={i === 0}
            handleOpenLightBox={handleOpenLightBox}
          />
        ))}
      </>
    );
  };

  const handleOpenCardMessageEdit = () => {
    setCardMessageEditDialogOpen(true);
  };

  const handleCloseCardMessageEdit = () => {
    setCardMessageEditDialogOpen(false);
  };

  const handleCardMessageUpdate = (updatedOrder: Order) => {
    setOrder(updatedOrder);
    setCardMessageEditDialogOpen(false);
  };

  const handleOpenRecipientDetailsEdit = () => {
    setRecipientDetailsEditDialogOpen(true);
  };

  const handleCloseRecipientDetailsEdit = () => {
    setRecipientDetailsEditDialogOpen(false);
  };

  const handleRecipientDetailsUpdate = (updatedOrder: Order) => {
    setOrder(updatedOrder);
    setRecipientDetailsEditDialogOpen(false);
  };

  const handleOpenAddressEdit = () => {
    setAddressEditDialogOpen(true);
  };

  const handleCloseAddressEdit = () => {
    setAddressEditDialogOpen(false);
  };

  const handleAddressUpdate = (updatedOrder: Order) => {
    setOrder(updatedOrder);
    setAddressEditDialogOpen(false);
  };

  const handleOpenDeliverySlotEdit = () => {
    setDeliverySlotEditDialogOpen(true);
  };

  const handleCloseDeliverySlotEdit = () => {
    setDeliverySlotEditDialogOpen(false);
  };

  const handleDeliverySlotUpdate = (updatedOrder: Order) => {
    setOrder(updatedOrder);
    setDeliverySlotEditDialogOpen(false);
  };

  const handleOpenLocationEdit = () => {
    setLocationEditDialogOpen(true);
  };

  const handleCloseLocationEdit = () => {
    setLocationEditDialogOpen(false);
  };

  const handleLocationUpdate = (updatedOrder: Order) => {
    setOrder(updatedOrder);
    setLocationEditDialogOpen(false);
  };

  const checkStepFunction = (order: Order | undefined) => {
    if (order?.status === 'pending') {
      return 1;
    } else if (order?.status === 'confirmed') {
      return 2;
    } else if (order?.status === 'shipped') {
      return 3;
    } else if (order?.status === 'delivered') {
      return 4;
    }
  };

  const handleChangeStatus = async (value: string) => {
    if (value && order?.id) {
      if (value !== OrderStatus.cancelled) {
        // If moving to confirmed (preparing in UI), check if exact delivery slot exists
        if (value === 'confirmed') {
          try {
            const result = await ExactDeliverySlot.find({ query: { orderId: order.id } });
            const hasExactSlot = Boolean(result && result.exactDeliverySlot);
            if (!hasExactSlot) {
              // Show dialog to select time slot first
              setPendingStatusChange(value);
              setExactDeliverySlotDialogOpen(true);
              return;
            }
          } catch (e) {
            // No slot found, show dialog to select time slot first
            setPendingStatusChange(value);
            setExactDeliverySlotDialogOpen(true);
            return;
          }
        }
        await proceedWithStatusChange(value);
      } else {
        onOpen();
      }
    }
  };

  const proceedWithStatusChange = async (status: string) => {
    if (order?.id) {
      try {
        const result = await dispatch(
          createOrderStatusChange({ orderId: order?.id, status })
        ).unwrap();
        if (IsNotNullOrEmpty(result)) {
          toast.success('Order status updated');
          const decodeParam = decryptString(params?.id ?? '');
          const record = await dispatch(getOrder({ id: decodeParam })).unwrap();
          setOrder(record);
        }
      } catch {
        // Error toast already shown by createOrderStatusChange
      }
    }
  };

  const handleClose = () => {
    setRefundForCancel(true);
    onClose();
  };

  const handleNo = async () => {
    setRefundForCancel(true);
    onClose();
  };

  const handleYes = async () => {
    if (order?.id) {
      try {
        const result = await dispatch(
          createOrderStatusChange({
            orderId: order?.id,
            status: OrderStatus.cancelled,
            isRefund: refundForCancel,
          })
        ).unwrap();
        if (IsNotNullOrEmpty(result)) {
          toast.success('Order cancelled');
          const decodeParam = decryptString(params?.id ?? '');
          const record = await dispatch(getOrder({ id: decodeParam })).unwrap();
          setOrder(record);
        }
      } catch {
        // Error toast already shown by createOrderStatusChange
      }
    }
    setRefundForCancel(true);
    onClose();
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleExactSlotDialogClose = () => {
    setExactDeliverySlotDialogOpen(false);
    setPendingStatusChange(null);
  };

  const handleExactSlotSaved = async () => {
    setExactDeliverySlotDialogOpen(false);
    if (pendingStatusChange && order?.id) {
      // Re-fetch latest order to avoid stale status (saving slot may update status server-side)
      const decodeParam = decryptString(params?.id ?? '');
      const latest = await dispatch(getOrder({ id: decodeParam })).unwrap();
      setOrder(latest);
      if (latest?.status !== pendingStatusChange) {
        await proceedWithStatusChange(pendingStatusChange);
      }
      setPendingStatusChange(null);
    }
  };

  const handleSaveSlot = async () => {
    if (exactDeliverySlotRef.current) {
      setSavingSlot(true);
      try {
        await exactDeliverySlotRef.current.handleSave();
        // Once saved successfully, onSlotUpdate will be called which triggers handleExactSlotSaved
      } finally {
        setSavingSlot(false);
      }
    }
  };

  // const handleMapClick = (e: L.LatLng) => {
  //   setMapCoordinates([e.lat, e.lng]);
  // };
  const handleLinkClick = (e: any) => {
    e.preventDefault();
    const mapUrl = `https://www.google.com/maps?q=${order?.shippingAddress?.latitude},${order?.shippingAddress?.longitude}`;
    window.open(mapUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
        >
          <Card sx={{ pt: 2, px: 2 }}>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                xs={12}
                sm={4}
                md={4}
              >
                <Typography
                  variant='h6'
                  gutterBottom
                >
                  {'Order Status'}
                </Typography>
              </Grid>
              <Grid
                item
                xs={0}
                sm={4}
                md={4}
              ></Grid>

              <Grid
                item
                xs={12}
                sm={4}
                md={4}
              >
                {(userRole === 'admin' || userRole === 'orderManager') && (
                  <FormControl fullWidth>
                    <InputLabel>Select Order Status</InputLabel>
                    <Select
                      id='orderStatus'
                      name='orderStatus'
                      value={order?.status}
                      onChange={(e) => {
                        handleChangeStatus(e.target.value);
                      }}
                      label='Select Order Status'
                      renderValue={(selected) => {
                        const selectedStatus = ORDER_STATUS.find(
                          (status) => status.value === selected
                        );
                        return (
                          <span
                            style={{
                              color: selectedStatus
                                ? selectedStatus.color
                                : 'inherit',
                              textTransform: 'capitalize',
                            }}
                          >
                            {selectedStatus ? selectedStatus.name : selected}
                          </span>
                        );
                      }}
                    >
                      {ORDER_STATUS.map((status) => {
                        return (
                          <MenuItem
                            key={status?.value}
                            value={status?.value}
                            sx={{
                              textTransform: 'capitalize',
                              color: `${status?.color} !important`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>{status?.name}</span>
                            {order?.status === status?.value && (
                              <span style={{ 
                                color: '#EE3750', 
                                fontWeight: 'bold',
                                backgroundColor: '#FDF0F1',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px'
                              }}>✓</span>
                            )}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                )}
              </Grid>
            </Grid>

            {order?.status === OrderStatus.cancelled ? (
              <Box
                display='flex'
                justifyContent='center'
                alignContent='center'
                mt={2}
                sx={{ width: '100%', p: 3.5 }}
              >
                <FaRegSadTear
                  color='red'
                  size={40}
                  style={{ marginRight: '0.5rem' }}
                />
                <Typography
                  variant='body2'
                  color='red'
                  fontSize='1rem'
                  display='flex'
                  alignItems='center'
                >
                  This order has been cancelled.
                </Typography>
              </Box>
            ) : (
              <Box sx={{ width: '100%', p: 3.5 }}>
                <Stepper
                  activeStep={checkStepFunction(order)}
                  alternativeLabel
                  connector={<QontoConnector />}
                  orientation={
                    window?.innerWidth <= 300 ? 'vertical' : 'horizontal'
                  }
                >
                  {steps.map((label) => (
                    <Step key={label?.name}>
                      <StepLabel StepIconComponent={QontoStepIcon}>
                        <Box
                          display='flex'
                          flexDirection='column'
                          alignItems='center'
                        >
                          <Box>{label.icon}</Box>
                          <Box
                            mt={1}
                            sx={{ fontWeight: 'bold' }}
                          >
                            {label.name}
                          </Box>
                        </Box>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>
            )}
          </Card>
        </Grid>
      </Grid>

      <Card
        sx={{ pt: 5, px: 5, mt: 2 }}
        elevation={1.0}
      >
        <>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={4}
              sx={{ mb: 5 }}
            >
              <Image
                src='/static/adori-logo.png'
                alt='adori'
                sx={{ maxWidth: 120 }}
              />
            </Grid>

            <Grid
              item
              xs={0}
              sm={4}
              sx={{ mb: 5 }}
            >
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              sx={{ mb: 5 }}
            >
              <Box sx={{ textAlign: { sm: 'right' } }}>
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={selectPaymentStatusColor(order?.status ?? '')}
                >
                  {/* {order?.status ?? ''} */}
                  {order?.status === 'shipped'
                    ? 'Out for Delivery'
                    : order?.status === 'confirmed'
                      ? 'Preparing'
                      : order?.status}
                </Label>

                <Box>
                  <Typography variant='h6' component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <span>Order No - {order?.orderNumber || '—'}</span>
                    {order?.isLate && (
                      <Label
                        variant='filled'
                        color='error'
                      >
                        <Box component="span" sx={{ display: 'flex', alignItems: 'center', fontSize: '0.75rem' }}>
                          <WarningIcon sx={{ fontSize: 14, mr: 0.5 }} />
                          LATE ORDER
                        </Box>
                      </Label>
                    )}
                  </Typography>
                </Box>

                <Typography variant='subtitle1'>
                  Identity -{' '}
                  <Label
                    variant='ghost'
                    color={order?.isIdentitySecret ? 'success' : 'error'}
                  >
                    {order?.isIdentitySecret ? 'Secret' : 'Not Secret'}
                  </Label>
                </Typography>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              sx={{ mb: 5, pr: 2 }}
            >
              <Typography
                paragraph
                variant='overline'
                sx={{ color: 'text.disabled' }}
              >
                Customer:
              </Typography>
              <Typography variant='body2'>
                {order?.userDetails?.firstName} {order?.userDetails?.lastName}
              </Typography>
              <Typography variant='body2'>
                Phone: {order?.userDetails?.mobileNumber ?? ''}
              </Typography>
              <Typography variant='body2'>
                Email: {order?.userDetails?.email ?? ''}
              </Typography>
                  {order?.userDetails?.id && (
                    <Typography variant='body2' color='text.secondary'>
                      <a
                        href='#'
                        onClick={(e) => {
                          e.preventDefault();
                          const encryptedId = encryptString(order.userDetails.id);
                          window.open(`/users/view/${encryptedId}`, '_blank');
                        }}
                        style={{ 
                          color: '#1976d2', 
                          textDecoration: 'underline',
                          cursor: 'pointer' 
                        }}
                      >
                        View User Profile
                      </a>
                    </Typography>
                  )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              sx={{ mb: 5, pr: 2 }}
            >
              <Typography
                paragraph
                variant='overline'
                sx={{ color: 'text.disabled' }}
              >
                Payment Method:
              </Typography>
              <Typography variant='body2'>
                {order?.country_payment_method?.labelEn}{' '}
                {order?.walletCreditUsed && order?.walletCreditUsed > 0
                  ? `+ Wallet (QAR ${order?.walletCreditUsed})`
                  : ''}
              </Typography>
              <Typography variant='body2'>
                {order?.country_payment_method?.labelAr}
              </Typography>
              <Typography variant='body2'>
                Code: {order?.country_payment_method?.code ?? ''}
              </Typography>
            </Grid>

            {order?.isIdentitySecret ? (
              <>
                {/* Recipient Details Section */}
                <Grid
                  item
                  xs={12}
                  sm={4}
                  sx={{ mb: 5, pr: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Typography
                      paragraph
                      variant='overline'
                      sx={{ color: 'text.disabled', mb: 0 }}
                    >
                      Recipient Details:
                    </Typography>
                    {(userRole === 'admin' || userRole === 'orderManager') && (
                      <IconButton
                        size="small"
                        onClick={handleOpenRecipientDetailsEdit}
                        sx={{ ml: 1 }}
                        title="Edit Recipient Details"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>
                  <Typography variant='body2'>
                    Name: {order?.recipientInfo?.name}
                  </Typography>
                  {order?.recipientInfo?.phone && (
                    <Typography variant='body2'>
                      Phone: {order?.recipientInfo?.phone ?? ''}
                    </Typography>
                  )}
                </Grid>

                {/* Delivery Address Section - Hidden for secret orders */}
                {!order?.isIdentitySecret && (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    sx={{ mb: 5, pr: 2 }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Typography
                        paragraph
                        variant='overline'
                        sx={{ color: 'text.disabled', mb: 0 }}
                      >
                        Delivery Address:
                      </Typography>
                      {(userRole === 'admin' || userRole === 'orderManager') && (
                        <IconButton
                          size="small"
                          onClick={handleOpenAddressEdit}
                          sx={{ ml: 1 }}
                          title="Edit Delivery Address"
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                    {order?.shippingAddress && (
                      <>
                        <Typography variant='body2'>
                          {order?.shippingAddress?.addressName}
                        </Typography>
                        <Typography variant='body2'>
                          Building No: {order?.shippingAddress?.buildingNumber}
                        </Typography>
                        <Typography variant='body2'>
                          Street No: {order?.shippingAddress?.street}
                        </Typography>
                        <Typography variant='body2'>
                          Zone: {order?.shippingAddress?.zone}
                        </Typography>
                        <Typography variant='body2'>
                          Region: {order?.shippingAddress?.region?.labelEn} (
                          {order?.shippingAddress?.region?.labelAr})
                        </Typography>
                        <Typography variant='body2'>
                          Country: {order?.shippingAddress?.country?.labelEn} (
                          {order?.shippingAddress?.country?.labelAr})
                        </Typography>
                        {order?.shippingAddress?.latitude &&
                          order?.shippingAddress?.longitude && (
                            <Typography variant='body2'>
                              <a
                                href='#'
                                onClick={handleLinkClick}
                              >
                                Open Location in Maps
                              </a>
                            </Typography>
                          )}
                      </>
                    )}
                  </Grid>
                )}
              </>
            ) : (
              <Grid
                item
                xs={12}
                sm={4}
                sx={{ mb: 5, pr: 2 }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography
                    paragraph
                    variant='overline'
                    sx={{ color: 'text.disabled', mb: 0 }}
                  >
                    Shipping Address:
                  </Typography>
                  {(userRole === 'admin' || userRole === 'orderManager') && (
                    <IconButton
                      size="small"
                      onClick={handleOpenAddressEdit}
                      sx={{ ml: 1 }}
                      title="Edit Shipping Address"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
                <Typography variant='body2'>
                  {order?.shippingAddress?.addressName},
                </Typography>
                <Typography variant='body2'>
                  Building No: {order?.shippingAddress?.buildingNumber},
                </Typography>
                <Typography variant='body2'>
                  Street No: {order?.shippingAddress?.street},
                </Typography>
                <Typography variant='body2'>
                  Zone: {order?.shippingAddress?.zone}
                </Typography>
                <Typography variant='body2'>
                  Region: {order?.shippingAddress?.region?.labelEn} (
                  {order?.shippingAddress?.region?.labelAr})
                </Typography>
                <Typography variant='body2'>
                  Country: {order?.shippingAddress?.country?.labelEn} (
                  {order?.shippingAddress?.country?.labelAr})
                </Typography>
                {order?.shippingAddress?.latitude &&
                  order?.shippingAddress?.longitude && (
                    <Typography variant='body2'>
                      <a
                        href='#'
                        onClick={handleLinkClick}
                      >
                        Open Location in Maps
                      </a>
                    </Typography>
                  )}
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sm={4}
              sx={{ mb: 5 }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography
                  paragraph
                  variant='overline'
                  sx={{ color: 'text.disabled', mb: 0 }}
                >
                  Delivery Slot:
                </Typography>
                {(userRole === 'admin' || userRole === 'orderManager') && (
                  <IconButton
                    size="small"
                    onClick={handleOpenDeliverySlotEdit}
                    sx={{ ml: 1 }}
                    title="Edit Delivery Slot"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              <Typography variant='body2'>
                {formatDate(String(order?.deliveryDate?.date ?? ''))}{' '}
                {order?.deliveryDate?.time}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              sx={{ mb: 5 }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography
                  paragraph
                  variant='overline'
                  sx={{ color: 'text.disabled', mb: 0 }}
                >
                  Card Message:
                </Typography>
                {(userRole === 'admin' || userRole === 'orderManager') && (
                  <IconButton
                    size="small"
                    onClick={handleOpenCardMessageEdit}
                    sx={{ ml: 1 }}
                    title="Edit Card Message"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              <Typography variant='body2'>
                To: {order?.cardMessage?.toUser}
              </Typography>
              <Typography
                variant='body2'
                style={{ textTransform: 'capitalize' }}
              >
                Message: {order?.cardMessage?.message}
              </Typography>
              <Typography
                variant='body2'
                style={{ textTransform: 'capitalize' }}
              >
                From: {order?.cardMessage?.fromUser}
              </Typography>
            </Grid>

            {order?.transactionId || order?.onlinePaymentId ? (
              <Grid
                item
                xs={12}
                sm={4}
                sx={{ mb: 5 }}
              >
                <Typography
                  paragraph
                  variant='overline'
                  sx={{ color: 'text.disabled' }}
                >
                  Payment references:
                </Typography>
                <Typography variant='body2' sx={{ wordBreak: 'break-all' }}>
                  Transaction ID: {order?.transactionId || '—'}
                </Typography>
                {order?.onlinePaymentId ? (
                  <Typography
                    variant='body2'
                    sx={{ wordBreak: 'break-all', mt: 0.5 }}
                  >
                    Dibsy payment id: {order.onlinePaymentId}
                  </Typography>
                ) : null}
              </Grid>
            ) : null}
          </Grid>

          <Box
            sx={{
              maxWidth: { xs: 550, sm: 850, md: 1150, lg: 1500 },
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              variant='scrollable'
              scrollButtons={true}
              aria-label='scrollable auto tabs example'
            >
              <Tab label={'Order Details'} />
              {order?.shippingAddress?.latitude &&
                order?.shippingAddress?.longitude && <Tab label={'Location'} />}
              <Tab label={'Cake Edit Logs'} />
            </Tabs>
          </Box>
          <TabPanel
            value={tabValue}
            index={0}
          >
            {hasCakeOrBundleItems(order) ? (
              <Scrollbar>
                <TableContainer sx={{ minWidth: 960 }}>
                  <Table>
                    <TableHead
                      sx={{
                        borderBottom: (theme) =>
                          `solid 1px ${theme.palette.divider}`,
                      }}
                    >
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell width={40}>#</TableCell>
                        <TableCell align='left'>{'Image'}</TableCell>
                        <TableCell align='right'>{'Custom Image'}</TableCell>
                        <TableCell align='right'>{'Print Image'}</TableCell>
                        <TableCell align='right'>{'Order Cake'}</TableCell>
                        <TableCell align='right'>{'Product Variant'}</TableCell>
                        <TableCell align='right'>{'Additional Guide'}</TableCell>
                        <TableCell align='right'>{'Write on Cake Board'}</TableCell>
                        <TableCell align='right'>{'Qty'}</TableCell>
                        <TableCell align='right'>{'Unit Price'}</TableCell>
                        <TableCell align='right'>{'Total'}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {renderOrderDetailRows()}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
            ) : null}
            <ServiceLinesPanel
              order={order}
              onOrderUpdated={setOrder}
              handleOpenLightBox={handleOpenLightBox}
            />
              <TableContainer sx={{ width: '100%' }}>
                <Table>
                  <TableBody>
                    <RowResultStyle>
                      <TableCell colSpan={9} />
                      <TableCell align='right'>
                        <Box sx={{ mt: 2 }} />
                        <Typography>{'Items Total'}</Typography>
                      </TableCell>
                      <TableCell
                        align='right'
                        width={120}
                      >
                        <Box sx={{ mt: 2 }} />
                        <Typography>
                          + {order ? sumOrderItems(order) : 0}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    <RowResultStyle>
                      <TableCell colSpan={9} />
                      <TableCell align='right'>
                        <Box sx={{ mt: 2 }} />
                        <Typography>{'Delivery Fee'}</Typography>
                      </TableCell>
                      <TableCell
                        align='right'
                        width={120}
                      >
                        <Box sx={{ mt: 2 }} />
                        <Typography>+ {order?.deliveryFee}</Typography>
                      </TableCell>
                    </RowResultStyle>

                    <RowResultStyle>
                      <TableCell colSpan={9} />
                      <TableCell align='right'>
                        <Box sx={{ mt: 2 }} />
                        <Typography>
                          {'Promo Discount'}
                          {order?.promo_code_usage?.promo_code?.code && (
                            <Typography variant="caption" display="block" color="text.secondary">
                              (Promo Code: <b>{order?.promo_code_usage?.promo_code?.code}</b>)
                            </Typography>
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell
                        align='right'
                        width={120}
                      >
                        <Box sx={{ mt: 2 }} />
                        <Typography>
                          -{' '}
                          {Number(order?.promoCodeDiscountAmount) > 0
                            ? Number(order?.promoCodeDiscountAmount)
                            : order?.promo_code_usage?.promo_code &&
                              order?.promo_code_usage?.promo_code?.discountType ===
                                'percentage off'
                            ? (Number(
                                order?.promo_code_usage?.promo_code
                                  ?.discountAmount
                              ) *
                                sumOrderItems(order)) /
                              100
                            : order?.promo_code_usage?.promo_code
                                ?.discountAmount}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    {Number(order?.rewardPointsRedeemed ?? 0) > 0 && (
                      <RowResultStyle>
                        <TableCell colSpan={9} />
                        <TableCell align='right'>
                          <Box sx={{ mt: 2 }} />
                          <Typography>{'Redeemed Points'}</Typography>
                        </TableCell>
                        <TableCell align='right' width={120}>
                          <Box sx={{ mt: 2 }} />
                          <Typography>
                            - {Number(order?.rewardPointsDiscountAmount ?? 0).toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                    )}

                    <RowResultStyle>
                      <TableCell colSpan={9} />
                      <TableCell align='right'>
                        <Box sx={{ mt: 2 }} />
                        <Typography>{'VAT'}</Typography>
                      </TableCell>
                      <TableCell
                        align='right'
                        width={120}
                      >
                        <Box sx={{ mt: 2 }} />
                        <Typography>
                          + {order?.vatAmount ? order?.vatAmount : 0}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    <RowResultStyle>
                      <TableCell colSpan={9} />
                      <TableCell align='right'>
                        <Typography variant='h6'>{'Total'}</Typography>
                      </TableCell>
                      <TableCell
                        align='right'
                        width={140}
                      >
                        <Typography variant='h6'>
                          {' '}
                          {parseFloat(
                            Number(order?.totalAmount ?? 0).toFixed(2)
                          )}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                  </TableBody>
                </Table>
              </TableContainer>
          </TabPanel>
          {order?.shippingAddress?.latitude &&
            order?.shippingAddress?.longitude && (
            <TabPanel
              value={tabValue}
              index={1}
            >
              {/* Location Coordinates Section */}
            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography
                  paragraph
                  variant='overline'
                  sx={{ color: 'text.disabled', mb: 0 }}
                >
                  Location Coordinates:
                </Typography>
                {(userRole === 'admin' || userRole === 'orderManager') && (
                  <IconButton
                    size="small"
                    onClick={handleOpenLocationEdit}
                    sx={{ ml: 1 }}
                    title="Edit Location Coordinates"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              {order?.shippingAddress?.latitude && order?.shippingAddress?.longitude ? (
                <>
                  <Typography variant='body2' sx={{ mb: 1 }}>
                    Latitude: {typeof order.shippingAddress.latitude === 'number' 
                      ? order.shippingAddress.latitude.toFixed(6) 
                      : order.shippingAddress.latitude}
                  </Typography>
                  <Typography variant='body2' sx={{ mb: 1 }}>
                    Longitude: {typeof order.shippingAddress.longitude === 'number' 
                      ? order.shippingAddress.longitude.toFixed(6) 
                      : order.shippingAddress.longitude}
                  </Typography>
                  <Typography variant='body2' sx={{ mb: 2 }}>
                    <a
                      href='#'
                      onClick={handleLinkClick}
                    >
                      Open Location in Maps
                    </a>
                  </Typography>
                </>
              ) : (
                <Typography variant='body2' color="text.secondary" sx={{ mb: 2 }}>
                  No location coordinates set
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                mt: 3,
              }}
            >
              <MapContainer
                center={mapCoordinates}
                zoom={8}
                style={{ height: '600px', width: '100%' }}
                attributionControl={false}
              >
                {/* <MapClickHandler handleClick={handleMapClick} /> */}
                <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
                {order?.shippingAddress?.latitude != null &&
                  order?.shippingAddress?.longitude != null && (
                    <Marker
                      position={[
                        order?.shippingAddress?.latitude,
                        order?.shippingAddress?.longitude,
                      ]}
                      icon={customIcon}
                    >
                      <Popup>{order?.orderNumber}</Popup>
                    </Marker>
                  )}
              </MapContainer>
            </Box>
            </TabPanel>
          )}
          <TabPanel
            value={tabValue}
            index={order?.shippingAddress?.latitude && order?.shippingAddress?.longitude ? 2 : 1}
          >
            <CakeEditLogs orderId={order?.id || ''} />
          </TabPanel>

          <Divider sx={{ mt: 5 }} />
        </>
      </Card>

      {openLightBox && (
        <div
          id='myModal'
          className='modal'
        >
          <span className='close cursor'>
            <CloseIcon
              fontSize='large'
              onClick={handleCloseLightBox}
              sx={{ mt: 'env(safe-area-inset-top) !important' }}
            />
          </span>
          <div
            className={`modal-content ${
              openLightBox ? 'display-block ' : 'display-none'
            }`}
          >
            {imageState && (
              <div className='vertical-center-div'>
                <div
                  ref={boxRef}
                  className={`mySlides ${
                    openLightBox ? 'display-block ' : 'display-none'
                  }`}
                >
                  <AssetLightBoxImage
                    imageKey={imageState}
                    assetUrl={assetUrl}
                    alt='Order image'
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <Dialog
        fullWidth
        open={toggle}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Order Cancel</DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography
            variant='h6'
            gutterBottom
          >
            Are you sure you want to cancel the order?
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                color='primary'
                name='activeState'
                onChange={(e) => setRefundForCancel(e.target.checked)}
                checked={refundForCancel}
              />
            }
            label={'Refund'}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleYes}
            variant='contained'
          >
            Yes
          </Button>
          <Button
            onClick={handleNo}
            variant='outlined'
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <RecipientLocationEditDialog
        open={locationEditDialogOpen}
        onClose={handleCloseLocationEdit}
        order={order}
        onLocationUpdate={handleLocationUpdate}
      />

      <CardMessageEditDialog
        open={cardMessageEditDialogOpen}
        onClose={handleCloseCardMessageEdit}
        order={order}
        onCardMessageUpdate={handleCardMessageUpdate}
      />

      <RecipientDetailsEditDialog
        open={recipientDetailsEditDialogOpen}
        onClose={handleCloseRecipientDetailsEdit}
        order={order}
        onRecipientUpdate={handleRecipientDetailsUpdate}
      />

        <AddressEditDialog
          open={addressEditDialogOpen}
          onClose={handleCloseAddressEdit}
          order={order}
          onAddressUpdate={handleAddressUpdate}
        />

        <DeliverySlotEditDialog
          open={deliverySlotEditDialogOpen}
          onClose={handleCloseDeliverySlotEdit}
          order={order}
          onDeliverySlotUpdate={handleDeliverySlotUpdate}
        />

        <LocationEditDialog
          open={locationEditDialogOpen}
          onClose={handleCloseLocationEdit}
          order={order}
          onLocationUpdate={handleLocationUpdate}
        />

        <Dialog 
          open={exactDeliverySlotDialogOpen} 
          onClose={handleExactSlotDialogClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            Edit Delivery Time Slot
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Update the delivery time slot for this order
            </Typography>
            {order && (
              <>
                <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
                  <Box sx={{ flex: 1 }}>
                    <ExactDeliverySlotSelector 
                      ref={exactDeliverySlotRef}
                      orderId={order.id} 
                      deliveryDate={order.deliveryDate?.date}
                      allowEdit={true}
                      hideSaveButton={true}
                      onSlotUpdate={() => {
                        // Slot was saved, proceed with status change
                        handleExactSlotSaved();
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1, p: 2, backgroundColor: '#FDF0F1', borderRadius: 1 }}>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Delivery Date:</strong> {order?.deliveryDate?.date && formatDate(order?.deliveryDate?.date)}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Delivery Time:</strong> {order?.deliveryDate?.time}
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontStyle: 'italic' }}>
                  <strong>Note:</strong> If you select 3 PM - 4 PM timeslot, order must be ready at 3 PM. If order will not be ready at 3:15 PM, it will be considered as late.
                </Typography>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleExactSlotDialogClose} color="inherit">
              Cancel
            </Button>
            <Button 
              onClick={handleSaveSlot} 
              variant="contained"
              sx={{ 
                backgroundColor: '#EE3750 !important', 
                '&:hover': { 
                  backgroundColor: '#EE3750 !important' 
                },
                '&:disabled': {
                  backgroundColor: '#c4cdd5',
                  color: '#fff'
                }
              }}
            disabled={savingSlot}
            >
              {savingSlot ? <CircularProgress size={20} /> : 'Save'}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
};

export default ViewOrder;

// const MapClickHandler: React.FC<{ handleClick: (e: L.LatLng) => void }> = ({
//   handleClick,
// }) => {
//   useMapEvents({
//     click: (e: any) => {
//       handleClick(e.latlng);
//     },
//   });
//   return null;
// };
